import { useState, useEffect } from 'react';
import { reportsApi } from '../api/reports';
import { enqueueReportRun } from '../api/runQueue';
import { prepareWidgetForRun } from '../utils/buildJoinSql';

function isAbortError(error) {
  return (
    error?.code === 'ERR_CANCELED' ||
    error?.name === 'CanceledError' ||
    error?.name === 'AbortError'
  );
}

/**
 * Fetch widget data via the shared /reports/run concurrency pool.
 * Preserves AbortController cancellation from the previous task.
 */
export function useWidgetData(widget, period, enabled) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!enabled) return undefined;

    const controller = new AbortController();
    let active = true;

    setLoading(true);
    setError(null);

    enqueueReportRun(
      () => reportsApi.run(prepareWidgetForRun(widget), period, { signal: controller.signal }),
      { signal: controller.signal },
    )
      .then((res) => {
        if (!active) return;
        setData(res.data);
        setLoading(false);
      })
      .catch((e) => {
        if (!active || controller.signal.aborted || isAbortError(e)) return;
        setError(e.response?.data?.error || 'خطا در بارگذاری داده');
        setLoading(false);
      });

    return () => {
      active = false;
      controller.abort();
    };
  }, [enabled, widget, period]);

  return { data, loading, error };
}
